export default "__VITE_ASSET__722a64e8__"